import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=61c0b8cd&scoped=true"
import script from "./customField.vue?vue&type=script&lang=js"
export * from "./customField.vue?vue&type=script&lang=js"
import style0 from "./customField.vue?vue&type=style&index=0&id=61c0b8cd&prod&scoped=true&lang=scss"
import style1 from "./customField.vue?vue&type=style&index=1&id=61c0b8cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0b8cd",
  null
  
)

export default component.exports